import { render, staticRenderFns } from "./StockAdjustment.vue?vue&type=template&id=a5543310&"
import script from "./StockAdjustment.vue?vue&type=script&lang=js&"
export * from "./StockAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports